<template>
	<el-container>
		<el-header class="title">
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/index/product' }">产品管理</el-breadcrumb-item>
						<el-breadcrumb-item>添加产品</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main style="position: relative;" v-loading="operating">
			<el-form :model="product" :rules="rules" ref="ruleForm" :inline="true" label-suffix=" : "
							 label-width="120px" size="medium" :style="mainStyleObject">
				<el-form-item label="产品名称" prop="name" >
					<el-input v-model="product.name" style="width: 400px;" placeholder="请输入产品名称"></el-input>
				</el-form-item>
				<el-form-item label="产品代码" prop="code">
					<el-input v-model="product.code" style="width: 400px;" placeholder="请输入产品代码"></el-input>
				</el-form-item>
				<el-form-item label="基金经理" prop="manager">
					<el-input v-model="product.manager" style="width: 400px;" placeholder="请输入基金经理"></el-input>
				</el-form-item>
				<!--<el-form-item label="资产管理人" prop="custodian">-->
					<!--<el-input v-model="product.custodian" style="width: 400px;" placeholder="请输入资产管理人"></el-input>-->
				<!--</el-form-item>-->
				<el-form-item label="托管人" prop="trustee">
					<el-input v-model="product.trustee" style="width: 400px;" placeholder="请输入托管人"></el-input>
				</el-form-item>
				<el-form-item label="券商" prop="security">
					<el-input v-model="product.security" style="width: 400px;" placeholder="请输入券商"></el-input>
				</el-form-item>
				<el-form-item label="期货公司" prop="futures">
					<el-input v-model="product.futures" style="width: 400px;" placeholder="请输入期货公司"> </el-input>
				</el-form-item>
				<el-form-item label="是否前端显示" style="width: 45%;" class="info-title">
					<el-radio-group v-model="product.status">
						<el-radio-button label="0">显示</el-radio-button>
						<el-radio-button label="1">不显示</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="产品分级" prop="categoryList" style="width: 90%;" class="info-title" :inline-message="true">
					<el-button type="primary" circle size="small" icon="el-icon-plus" @click="addItem()"></el-button>
				</el-form-item>
				<div class="category-form-item" style="padding: 0 30px;box-sizing: border-box;margin-top: -10px;">
					<el-table :data="product.categoryList"  header-cell-class-name="table_header" row-key="id" border size="small">
						<el-table-column prop="name" label="分级名称" min-width="350" >
							<template slot-scope="scope">
								<el-input v-model="scope.row.name" placeholder="请输入分级名称"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="分级代码" min-width="200" >
							<template slot-scope="scope">
								<el-input v-model="scope.row.code" placeholder="请输入分级代码"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="description" label="分级描述" min-width="350">
							<template slot-scope="scope">
								<el-input type="textarea"  :autosize="{ minRows: 1,maxRows:3}" v-model="scope.row.description"  placeholder="请输入分级描述"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" min-width="100">
							<template slot-scope="scope">
								<el-button class="el-button--danger " circle size="small" icon="el-icon-delete"  @click="removeItem(scope.$index)" v-if="scope.$index>0"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-form-item label="开放日描述" prop="opendayremind" style="width: 90%;" class="info-title">
				</el-form-item>
				<div style="padding: 0 30px;box-sizing: border-box;margin-bottom: 10px;margin-top: -10px;" >
					<el-input type="textarea" :rows="5" v-model="product.opendayremind" size="medium" style="min-width: 500px;"></el-input>
				</div>
				<el-form-item label="产品描述" prop="description" style="width: 90%;" class="info-title">
				</el-form-item>
				<div style="padding: 0 30px;box-sizing: border-box;margin-bottom: 10px;margin-top: -10px;">
					<el-input type="textarea" :rows="20" v-model="product.description" size="medium" style="min-width: 500px;"></el-input>
				</div>
			</el-form>
			<div style="line-height: 40px;background:#fff;border-top: 1px solid #ddd;padding: 5px 10px 0 10px;">
				<el-button type="primary" size="small" @click="submit('ruleForm')" style="width: 80px;">确定</el-button>
				<!--<el-button type="info" size="small" @click="reset('ruleForm')" style="width: 80px;">重置</el-button>-->
			</div>
		</el-main>
	</el-container>
</template>
<script>
	import config from "../../../config/global.js";
	import axios from "axios"

	export default {
		components: {
		},
		data() {
			return {
				product:{
				  code:'',
					name:'',
					custodian:'',
					trustee:'',
					security:'',
					futures:'',
					manager:'',
					description:'',
					status:0,
					categoryList:[
						{
							name:'',
							description:''
						}
					],
				},
				rules: {
					name: [
						{ required: true, message: '请输入产品名称', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入产品代码', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 30 个字符', trigger: 'blur' }
					],
					// custodian: [
					// 	{ required: true, message: '请输入资产管理人', trigger: 'blur' },
					// 	{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					// ],
					trustee: [
						{ required: true, message: '请输入托管人', trigger: 'blur' },
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					security:[
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					futures: [
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					manager: [
						{ required: true, message: '请输入基金经理', trigger: 'blur' },
						{ min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
					],
					// description: [
					// 	{ required: true, message: '请填写详细信息', trigger: 'blur' }
					// ],
					categoryList: [
						{ type:'array',required: true, message: '请添加产品分类', trigger: 'change' }
					]
				},
				operating:false,
				changed:false,
				mainStyleObject:{
					"height":window.innerHeight-170+"px",
					"overflow-y":"auto",
					"padding":"20px 10px 10px 10px",
					"box-sizing":"border-box"
				}
			}
		},
		props:{

		},
		methods:{
			addItem(index){
				var newCategory = {name:"",description:""};
				this.product.categoryList.splice(this.product.categoryList.length,0,newCategory)
			},
			removeItem(index){
				this.product.categoryList.splice(index,1)
			},
			close(){
				if(this.changed){
					this.$confirm('数据已更改，是否放弃修改?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.back();
					}).catch(() => {

					});
				}else{
					this.$router.back();
				}
			},
			submit(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.operating = true;
						axios({
							method: 'post',
							url:config.host+'/backend/product/add.json',
							data:this.product
						}).then((response)=>{
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							if(response.data.result == 1){
								this.$message({
									message: '产品创建成功',
									type: 'success'
								});
								this.$router.back();
							}else{
								this.$alert(response.data.emsg, '创建失败', {
									confirmButtonText: '确定'
								});
							}
							this.operating = false;
							console.log(response.data)
						}).catch((error)=>{
							this.operating = false;
							this.$alert(error.response.statusText, '创建失败', {
								confirmButtonText: '确定'
							});
						})
					} else {
						return false;
					}
				});
			},
			reset(formName) {
				this.$refs[formName].resetFields();
			}
		},
		watch:{
			product:{
				handler:function(){
					this.changed = true;
				},
				deep:true
			}
		}
	}
</script>
<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}

</style>



// WEBPACK FOOTER //
// src/layouts/product/AddProduct.vue